// auth.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface UseRsocial {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    provider: 'google' | 'facebook' | 'local';
}

@Injectable({
    providedIn: 'root'
})
export class AuthRsocialService {
    public static readonly PROVIDER_GOOGLE = 'google';
    public static readonly PROVIDER_FACEBOOK = 'facebook';
    public static readonly PROVIDER_LOCAL = 'local';

    private readonly USER_STORAGE_KEY = 'current_user';
    private userSubject = new BehaviorSubject<UseRsocial | null>(null);
    public user$: Observable<UseRsocial | null> = this.userSubject.asObservable();

    constructor() {
        // Charger l'utilisateur au démarrage du service
        this.loadUserFromStorage();
    }

    // Charger l'utilisateur depuis le localStorage
    private loadUserFromStorage(): void {
        try {
            const userData = localStorage.getItem(this.USER_STORAGE_KEY);
            if (userData) {
                const user: UseRsocial = JSON.parse(userData);
                this.userSubject.next(user);
                // console.log('Utilisateur chargé depuis le localStorage:', user);
            }
        } catch (error) {
            console.error('Erreur lors du chargement de l\'utilisateur:', error);
            this.clearUser();
        }
    }

    // Sauvegarder l'utilisateur
    saveUser(user: UseRsocial): void {
        try {
            localStorage.setItem(this.USER_STORAGE_KEY, JSON.stringify(user));
            this.userSubject.next(user);
            // console.log('Utilisateur sauvegardé:', user);
        } catch (error) {
            console.error('Erreur lors de la sauvegarde:', error);
        }
    }

    // Obtenir l'utilisateur actuel
    getCurrentUser(): UseRsocial | null {
        return this.userSubject.value;
    }

    // Vérifier si l'utilisateur est connecté
    isLoggedIn(): boolean {
        return this.getCurrentUser() !== null;
    }

    // Déconnecter l'utilisateur
    logout(): void {
        this.clearUser();
        // console.log('Utilisateur déconnecté');
    }

    // Nettoyer les données utilisateur
    private clearUser(): void {
        localStorage.removeItem(this.USER_STORAGE_KEY);
        this.userSubject.next(null);
    }

    // Traiter la réponse Google
    handleGoogleResponse(googleUserInfo: any): void {
        const user: UseRsocial = {
            firstName: googleUserInfo.given_name || '',
            lastName: googleUserInfo.family_name || '',
            email: googleUserInfo.email || '',
            phone: '',
            provider: AuthRsocialService.PROVIDER_GOOGLE
        };
        this.saveUser(user);
    }

    // Traiter la réponse Facebook
    handleFacebookResponse(facebookUserInfo: any): void {
        const user: UseRsocial = {
            firstName: facebookUserInfo.first_name || '',
            lastName: facebookUserInfo.last_name || '',
            email: facebookUserInfo.email || '',
            phone: '',
            provider: AuthRsocialService.PROVIDER_FACEBOOK
        };
        this.saveUser(user);
    }
}